import BaseContract from "../../BaseContract";

export default class BaseErc721Contract extends BaseContract {}
